import { CxEvent } from '@spartacus/core';

export class FbqGgCheckoutInitiateEvent extends CxEvent {
  event?: string;
}
